var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from 'react';
import { MdClose } from 'react-icons/md';
import { Flex, Card, Text, TextOrNode, Icon, Button } from "./..";
import { PaletteVariantsEnum } from "../../lss";
import { getIconAriaLabel, getCardPaletteIcon, getCardBorderLss, getIconColor } from './lib';
var cancelButtonLss = {
    p: 'none',
    width: '1.25rem',
    height: '1.25rem',
    borderRadius: 'rounded',
    alignSelf: 'center',
    ml: 'auto'
};
export var InlineNotification = function (_a) {
    var title = _a.title, children = _a.children, _b = _a.palette, palette = _b === void 0 ? PaletteVariantsEnum.PRIMARY : _b, customIcon = _a.customIcon, _c = _a.lss, lss = _c === void 0 ? {} : _c, _d = _a.iconLss, iconLss = _d === void 0 ? {} : _d, _e = _a.isDismissable, isDismissable = _e === void 0 ? false : _e, onDismiss = _a.onDismiss;
    var _f = __read(React.useState(true), 2), isVisible = _f[0], setIsVisible = _f[1];
    var handleDismiss = function () {
        if (onDismiss)
            onDismiss();
        setIsVisible(false);
    };
    var baseIcon = getCardPaletteIcon(palette);
    if (!isVisible)
        return null;
    return (React.createElement(Card, { lss: __assign(__assign({ p: 'lg', paddingBottom: 20, flexDirection: title ? 'column' : 'row' }, getCardBorderLss(palette)), lss) },
        React.createElement(Flex, null,
            React.createElement(Icon, { "aria-label": getIconAriaLabel(palette), as: customIcon || baseIcon, size: 20, lss: __assign({ mr: 'sm', alignSelf: 'center', color: getIconColor(palette) }, iconLss) }),
            title && React.createElement(Text, { lss: { fontWeight: 'bold' } }, title),
            isDismissable && (React.createElement(Button, { emphasis: "low", lss: cancelButtonLss, palette: PaletteVariantsEnum.PRIMARY, onClick: handleDismiss },
                React.createElement(Icon, { as: MdClose, size: 18, lss: { color: 'gray800' } })))),
        React.createElement(Flex, { lss: { pl: title ? 'xs' : 'none', ml: title ? 'xl' : 'none' } },
            React.createElement(TextOrNode, { lss: { textScale: 'control' } }, children))));
};
//# sourceMappingURL=InlineNotification.js.map